module.exports = __webpack_public_path__ + "img/locked.5a6ce08e.png";